import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import Update_data_modal from "../../components/manageInvoice/update_data_modal/index";
import DataTable_Component from "../../components/clientorders/Data Table/index";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faPenToSquare,
  faTrash,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";

import Layouts from "../../layouts/layouts";
import Add_data_modal from "../../components/clientorders/update_data_modal";
import * as XLSX from "xlsx";
import ClientOrdersDetailModal from "../../components/clientorders/Order Details";

export default function ClientOrders() {
  const title = "Client Orders Details";
  const navigate = useNavigate();
  const [apistate, setApiState] = useState([]);
  const [apicol, setApiCol] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);

  const [open_add_modal, setOpen_add_modal] = useState({
    render: true,
    modal_open: false,
  });

  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [update_modal_data, setUpdate_modal_data] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [showClientOrdersDetailModal, setShowClientOrdersDetailModal] =
    useState(false);
  const [selectedClientOrders, setSelectedClientOrders] = useState(null);

  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };
  const columns = [
    {
      name: <b>Number Plate</b>,
      selector: (row) => (row.vehicle_id ? row.vehicle_id.numberplate : "-"),
      sortable: true,
    },
    {
      name: <b>Client</b>,
      selector: (row) => (row.client_id ? row.client_id.name : "-"),
      sortable: true,
    },

    {
      name: <b>Driver Name</b>,
      selector: (row) => (row.driver_id ? row.driver_id.name : "-"),
      sortable: true,
    },
    {
      name: <b>Customer Name</b>,
      selector: (row) =>
        row.customer_detail ? row.customer_detail.customer_name : "-",
      sortable: true,
    },
    {
      name: <b>Delivery Date</b>,
      selector: (row) => formatDate(row.delivery_date),
      sortable: true,
    },
    {
      name: <b>Order Status</b>,
      selector: (row) => row.order_status,
      sortable: true,
    },

    {
      name: <b>Action</b>,
      cell: (row) => (
        <>
          <button
            onClick={() => setUpdateStoreBtn(row)}
            className="btn btn-info btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faPenToSquare} />
          </button>
          <button
            onClick={() => viewClientOrders(row)}
            className="btn btn-primary btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faEye} />
          </button>
        </>
      ),
    },
  ];

  const exportToExcel = () => {
    const transformedData = apistate.map((clientorders) => ({
      "Client Name": clientorders.client_id ? clientorders.client_id.name : "-",
      "Hub Name": clientorders.hub_id ? clientorders.hub_id.name : "-",

      "Order Status": clientorders.order_status,
      "Total Amount": clientorders.total_amount,
      "Delivery Date": clientorders.delivery_date,
      "Delivery Address": clientorders.delivery_address,

      "DA Name": clientorders.daUserId ? clientorders.daUserId.name : "-",
      "Driver Name": clientorders.driver_id ? clientorders.driver_id.name : "-",
      "Vehicle Numberplate": clientorders.vehicle_id
        ? clientorders.vehicle_id.numberplate
        : "-",
      "Customer Name": clientorders.customer_detail
        ? clientorders.customer_detail.customer_name
        : "-",
      "Customer Address": clientorders.customer_detail
        ? clientorders.customer_detail.customer_phone
        : "-",
    }));

    const worksheet = XLSX.utils.json_to_sheet(transformedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Client Orders");

    XLSX.writeFile(workbook, "clientorders.xlsx");
  };

  const handleShow = (row) => {
    setOpenModal(!openModal);
    setSelectval(row);
  };

  const fetchData = async (page) => {
    try {
      const token = localStorage.getItem("token");
      const userRole = localStorage.getItem("userRole"); // Get user role

      if (!token) {
        console.error("No token found");
        return;
      }

      // Determine API URL based on role
      let apiUrl;
      if (userRole === "superadmin") {
        apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v3/client-order/all`;
      } else if (userRole === "admin") {
        apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v3/admin/clientorders`;
      } else if (userRole === "clientmanager") {
        apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v3/clientmanager/clientorders`;
      } else {
        console.error("Unauthorized role:", userRole);
        return;
      }

      const response = await axios.get(apiUrl, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (Array.isArray(response.data.orders)) {
        setApiState(response.data.orders);
      } else {
        console.error("Unexpected data format from API", response.data);
      }

      setApiCol(columns);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  const setStoreBtn = () => {
    setOpen_add_modal({ render: !open_add_modal.render, modal_open: true });
  };

  const setUpdateStoreBtn = (row) => {
    setOpen_update_modal({
      render: !open_update_modal.render,
      modal_open: true,
    });
    setUpdate_modal_data(row);
  };

  const viewClientOrders = (clientorders) => {
    setSelectedClientOrders(clientorders);
    setShowClientOrdersDetailModal(true);
  };
  const updateClientOrders = (updatedClientOrders) => {
    setApiState((prev) =>
      prev.map((clientorders) =>
        clientorders._id === updateClientOrders._id
          ? updatedClientOrders
          : clientorders
      )
    );
  };

  const handleUpdateClientOrders = (updatedClientOrdersData) => {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found");
      return;
    }

    axios
      .put(
        `${process.env.REACT_APP_BASE_URL}/api/v3/client-order/${updatedClientOrdersData._id}`,
        updatedClientOrdersData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        Swal.fire(
          "Updated!",
          "ClientOrders details have been updated.",
          "success"
        );
        updateClientOrders(response.data.order);
      })
      .catch((error) => {
        Swal.fire(
          "Error!",
          "ClientOrders details could not be updated.",
          "error"
        );
        console.error(
          "Error updating data:",
          error.response ? error.response.data : error.message
        );
      });
  };

  const handleMapNavigation = (date) => {
    console.log("Navigating to Map with Date:", date); // Log selected date
    navigate(`/mymapcomponentorderview`, {
      state: {
        date: date,
      },
    });
  };

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />
      <Add_data_modal
        select_data={update_modal_data}
        open_update_data_modal={open_update_modal}
        onUpdateClientOrders={updateClientOrders}
      />
      <ClientOrdersDetailModal
        show={showClientOrdersDetailModal}
        onHide={() => setShowClientOrdersDetailModal(false)}
        clientorders={selectedClientOrders}
      />
      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between border-bottom pb-1">
                <h4>{title}</h4>
                <div>
                  <button
                    className="btn btn-info btn-sm ms-1"
                    onClick={() => handleMapNavigation()}
                  >
                    <FontAwesomeIcon icon={faMapMarkerAlt} />
                  </button>{" "}
                  <Link to="/create_clientorders">
                    <div className="btn btn-info btn-sm text-white me-2">
                      Add Client Order
                    </div>
                  </Link>
                </div>
              </div>
              <div className="card-body">
                {apistate.length > 0 ? (
                  <DataTable_Component
                    searchBy="vehicle_id"
                    title_btn={true}
                    title="Order List"
                    apidata={apistate}
                    columns={apicol}
                  />
                ) : (
                  <p>Loading...</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
